import { FrequentlyAskedQuestionFormType } from 'components/frequently-asked-questions/FrequentlyAskedQuestionForm';

export const updateFrequentlyAskedQuestionsInitialValues: Partial<FrequentlyAskedQuestionFormType> = {};
